import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const Footer = ({ children }) => (
  <Row className="h-100 align-items-center">
    <Col className="text-right">{children}</Col>
  </Row>
);

Footer.propTypes = {
  children: PropTypes.node,
};

export default Footer;
